<template>
  <span>
    <Dialog
      class="test-box"
      header="Cancelar Nota Fiscal"
      :visible.sync="showCancelarNota"
      :modal="true"
      :closable="false"
      :style="{ width: '80em' }"
    >
      <h1 class="titulo-header">
        Cancelar Nota Fiscal
        <Button
          id="icon-close-modals"
          icon="pi pi-times"
          class="p-button-rounded p-button-text"
          @click="showCancelarNota = false"
        />
      </h1>
      <hr/>
      <br />
      <div>
        <div class="row">
          <div class="col-md-12 mb-2 mensagem-cancelamento" style="text-align: left;">
            <p v-if="utilizarTermoCancelamento">
              {{ this.notaPaga ? mensagemPagamento : mensagemCancelamento }}
            </p>
          </div>
        </div>

        <div id="topo" class="row" v-if="!termoCriado">
          <div class="col-md-12 mb-2">
            <label for="tipoTomador">Observação: *</label>
            <span class="p-fluid">
              <textarea v-model="observacao" rows="5" maxlength="255" />
            </span>
          </div>
        </div>
      </div>

      <hr />

      <div class="container-fluid">
        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
          
          <div class="actions-left" style="display: flex; gap: 0.5rem;">
            <Button
              class="p-button-primary p-button-info"
              type="button"
              v-if="utilizarTermoCancelamento && termoCriado"
              :disabled="loading"
              @click="abrirModalUpload()"
              :label="termoAnexado ? 'Alterar Arquivo' : 'Anexar Arquivo'"
              icon="pi pi-upload"
            />
            
            <Button
              class="p-button-secondary"
              type="button"
              v-if="utilizarTermoCancelamento && termoCriado && termoAnexado"
              :disabled="loading"
              @click="visualizarAnexo()"
              icon="pi pi-eye"
              v-tooltip.top="'Visualizar termo assinado anexado'"
            />

            <Button
              class="p-button-danger"
              type="button"
              v-if="utilizarTermoCancelamento && termoCriado && termoAnexado"
              :disabled="loading"
              @click="showDeleteDialog = true"
              icon="pi pi-trash"
              v-tooltip.top="'Excluir anexo'"
            />
          </div>

          <div class="actions-right" style="display: flex; gap: 0.5rem;">
            <Button
              @click="cancelarNfse()"
              href="#topo"
              type="button"
              label="Cancelar"
              class="p-button-primary p-button-success"
              icon="pi pi-check"
              :disabled="loading"
              v-if="!utilizarTermoCancelamento"
            />

            <Button
              @click="emitirTermo()"
              href="#topo"
              type="button"
              label="Emitir Termo de Cancelamento"
              class="p-button-primary p-button-success"
              icon="pi pi-file"
              :disabled="loading"
              v-if="utilizarTermoCancelamento"
            />

            <Button
              class="p-button-primary"
              type="button"
              v-if="utilizarTermoCancelamento && termoCriado"
              :disabled="loading"
              @click="anularTermoCancelamento()"
              label="Desfazer Termo de Cancelamento"
              icon="pi pi-undo"
            />

            <Button
              @click="showCancelarNota = false"
              type="button"
              label="Fechar"
              class="p-button-primary p-button-danger"
              icon="pi pi-times"
            />
          </div>
        </div>
      </div>
      <Dialog
        header="Anexar Termo Assinado"
        :visible.sync="showUploadDialog"
        :modal="true"
        :style="{ width: '650px', minHeight: '450px' }" 
        class="dialog-arredondado" 
      >
        <div class="p-fluid">
          <div class="field">
            <label class="mb-2 font-weight-bold">Arquivo do Termo Assinado:</label>

            <input
              type="file"
              id="fileUpload"
              ref="fileInput"
              style="display: none"
              accept=".pdf,.jpg,.jpeg,.png"
              @change="onFileSelected"
            />

            <div 
              class="custom-upload-box" 
              :class="{ 'has-file': arquivoSelecionado }"
              @click="$refs.fileInput.click()"
            >
              <i
                class="mb-3"
                :class="arquivoSelecionado ? 'pi pi-check-circle' : 'pi pi-cloud-upload'"
                :style="{ fontSize: '3rem', color: arquivoSelecionado ? '#28a745' : '#6c757d' }"
              ></i>

              <span class="upload-title">
                {{ arquivoSelecionado ? arquivoSelecionado.name : 'Clique aqui para selecionar o arquivo' }}
              </span>

              <small class="upload-subtitle mt-2" v-if="!arquivoSelecionado">
                Formato: PDF (Máx: 15MB)
              </small>
              <small class="text-success font-weight-bold mt-2" v-if="arquivoSelecionado">
                Tamanho: {{ (arquivoSelecionado.size / 1024 / 1024).toFixed(2) }} MB
              </small>
            </div>

            <div class="text-right mt-3" v-if="arquivoSelecionado">
              <Button 
                  label="Remover Seleção" 
                  class="p-button-sm btn-remove-selection" 
                  icon="pi pi-trash"
                  @click="limparSelecaoArquivo($event)"
              />
            </div>
          </div>
        </div>

        <template #footer>
          <div class="dialog-footer-custom">
            <Button
              label="Cancelar"
              icon="pi pi-times"
              @click="showUploadDialog = false"
              class="p-button-primary mr-2 p-button-danger"
            />
            <Button
              label="Salvar Arquivo"
              icon="pi pi-check"
              @click="enviarArquivo"
              :disabled="!arquivoSelecionado || loading"
              autofocus
            />
          </div>
        </template>
      </Dialog>

      <Dialog
        header="Confirmar Exclusão"
        :visible.sync="showDeleteDialog"
        :modal="true"
        :style="{ width: '530px', minHeight: '355px' }"
        :closable="false"
        class="dialog-arredondado"
      >
        <div class="confirmation-content">
          <div class="warning-icon-wrapper mb-3">
            <i class="pi pi-exclamation-triangle warning-icon"></i>
          </div>
          <span class="confirmation-title">Atenção!</span>
          <p class="confirmation-message mt-2">
            Tem certeza que deseja <b>excluir permanentemente</b> o anexo deste Termo?
            <br>
            <small class="text-muted">Esta ação não poderá ser desfeita.</small>
          </p>
        </div>

        <template #footer>
          <div class="dialog-footer-custom">
            <Button 
              label="Não" 
              icon="pi pi-times" 
              @click="showDeleteDialog = false"
            />
            <Button 
              label="Sim, Excluir" 
              icon="pi pi-trash" 
              class="p-button-danger" 
              @click="excluirAnexoExec()" 
              :disabled="loading"
              autofocus
            />
          </div>
        </template>
      </Dialog>
    </Dialog>
  </span>
</template>

<script>
import NotaFiscalService from "@/services/nfse/notafiscal.service";
import NotaFiscalTesteService from "@/services/nfse/notafiscalteste.service";
import LoginService from "@/services/acesso/login.service";
import ReportService from "@/services/report.service";

export default {
  name: "CancelarNotaFiscal",

  created() {
    this.currentUser = LoginService.currentUserValue;
    this.cancPorSolicitacao = this.currentUser.configuracao.nfCancelamentoCienciaTomador  === 'S' ? true : false;
    this.diasPrazoCancelamento =
      this.currentUser.configuracao.nfPrazoDiasCancelamento || 0;
    if(this.currentUser.contribuinte && this.currentUser.contribuinte.optanteSs &&  this.currentUser.contribuinte.optanteSs === 'Sim' && this.currentUser.configuracao.nfPrazoDiasCancelamentoSimples){
      this.diasPrazoCancelamento = this.currentUser.configuracao.nfPrazoDiasCancelamentoSimples;
    }

    // if(this.currentUser.usuario.idCliente === "19533831040781681800D2584C905F8A"){
    //   this.mensagemCancelamento =
    //   "Clique no botão abaixo para emissão do Termo de Pedido de Cancelamento de NFS-e. Esse Termo deve ser ASSINADO pelo Prestador e Tomador do Serviço e entregue à SEFAZ via processo administrativo.";
    // }else if (this.diasPrazoCancelamento === -1) {
    //   this.mensagemCancelamento =
    //     "O período máximo para cancelamento automático foi ultrapassado (Prazo de dias conforme o vencimento da Nota Fiscal). Caso realmente deseje cancelar esta nota, informe o motivo e a nota fiscal substituta (caso houver) e clique no botão abaixo para emissão do Termo de Pedido de Cancelamento de NFS-e. Este Termo deve ser ASSINADO pelo Prestador e Tomador do Serviço e entregue na Prefeitura.";
    // } else {
    //   this.mensagemCancelamento =
    //     "O período máximo para cancelamento automático foi ultrapassado (" +
    //     this.diasPrazoCancelamento +
    //     " dias corridos da emissão da NFS-e). Caso realmente deseje cancelar esta nota, informe o motivo e a nota fiscal substituta (caso houver) e clique no botão abaixo para emissão do Termo de Pedido de Cancelamento de NFS-e. Este Termo deve ser ASSINADO pelo Prestador e Tomador do Serviço e entregue na Prefeitura.";
    // }
    this.$root.$on("notaFiscal:cancelar", (notaFiscal) => {
      this.notaPaga = false;
      this.idNotaFiscal = notaFiscal.id;
      this.dataGeracao = notaFiscal.dataGeracao;
      this.validacao = notaFiscal.validacao;
      this.cancDamPetrolina = notaFiscal.cancDamPetrolina;
      this.utilizarTermoCancelamento = false;
      this.isEmissaoTesteValidacao = notaFiscal.isEmissaoTesteValidacao;
      this.termoAnexado = false;

      //especifico joao monlevade
      let idCliente = '6866f81d-967e-4808-bb27-0dcf85594275';//""
      let cancelamentoCienciaTomador = (this.currentUser.configuracao.nfCancelamentoCienciaTomador && this.currentUser.configuracao.nfCancelamentoCienciaTomador === 'S')|| false;

      let diferencaDias = this.moment().diff(this.dataGeracao, 'days');
      if(this.currentUser.usuario.idCliente === "19533831040781681800D2584C905F8A"){
        this.mensagemCancelamento =
          "Clique no botão abaixo para emissão do Termo de Pedido de Cancelamento de NFS-e. Esse Termo deve ser ASSINADO pelo Prestador e Tomador do Serviço e entregue à SEFAZ via processo administrativo.";
      } else if(cancelamentoCienciaTomador && this.currentUser.usuario.idCliente === idCliente && diferencaDias < 60){
        this.mensagemCancPadrao =
          "Caso realmente deseje cancelar esta nota, informe o motivo e clique no botão abaixo para emissão do Termo de Pedido de Cancelamento de NFS-e.\n"+
          "Para que o cancelamento seja processado, o Termo de Pedido de Cancelamento de NFS-e deverá conter o aceite do Tomador da Nota Fiscal. Após o aceite do Tomador, o Fiscal analisará o pedido e decidirá se ele será deferido ou indeferido."
        
        this.mensagemCancAdicional = this.currentUser.configuracao.msgTermoCancNfse;
        this.mensagemCancelamento = `${this.mensagemCancPadrao}${
          this.mensagemCancAdicional ? `\n\n${this.mensagemCancAdicional}` : ""
        }`;
      }else if (this.diasPrazoCancelamento === -1) {
        this.mensagemCancelamento =
          "O período máximo para cancelamento automático foi ultrapassado (Prazo de dias conforme o vencimento da Nota Fiscal). Caso realmente deseje cancelar esta nota, informe o motivo e a nota fiscal substituta (caso houver) e clique no botão abaixo para emissão do Termo de Pedido de Cancelamento de NFS-e. Este Termo deve ser ASSINADO pelo Prestador e Tomador do Serviço e entregue na Prefeitura.";
      } else {
        // this.mensagemCancelamento =
        //   "O período máximo para cancelamento automático (" + this.diasPrazoCancelamento + " dias) foi ultrapassado (" +
        //   diferencaDias +
        //   " dias corridos da emissão da NFS-e). Caso realmente deseje cancelar esta nota, informe o motivo e a nota fiscal substituta (caso houver) e clique no botão abaixo para emissão do Termo de Pedido de Cancelamento de NFS-e. Este Termo deve ser ASSINADO pelo Prestador e Tomador do Serviço e entregue na Prefeitura.";
        /**Configuração Mensagem Termo de Cancelamento */
        this.mensagemCancPadrao =
            "O período máximo para cancelamento automático (" + this.diasPrazoCancelamento + " dias) foi ultrapassado (" +
            diferencaDias +
            " dias corridos da emissão da NFS-e). Caso realmente deseje cancelar esta nota, informe o motivo e a nota fiscal substituta (caso houver) e clique no botão abaixo para emissão do Termo de Pedido de Cancelamento de NFS-e."

        this.mensagemCancAdicional = this.currentUser.configuracao.msgTermoCancNfse;
        this.mensagemCancelamento = `${this.mensagemCancPadrao}${
          this.mensagemCancAdicional ? `\n\n${this.mensagemCancAdicional}` : ""
        }`;
      }

      if (!this.validacao) {
        //acionado bpelo botão de cancelamento direto somente admins!
        this.exibirDialogCancelarNota(false);
      } else {
          const servicoAtivo = this.isEmissaoTesteValidacao ? NotaFiscalTesteService : NotaFiscalService; 
          servicoAtivo.validarCancelamentoNfse(this.idNotaFiscal)
            .then(
              (response) => {
                if (response.data == "E" || response.data == "EP" || response.data == "EA") {
                  this.notaPaga = (response.data === "EP" ? true : false);
                  this.utilizarTermoCancelamento = true;
                  this.exibirDialogCancelarNota(true);
                  this.termoAnexado = true;
                  this.verificarSeExisteAnexo(this.idNotaFiscal);
                }else if(response.data == "P"){
                  this.notaPaga = true;
                  this.utilizarTermoCancelamento = true;
                  this.exibirDialogCancelarNota(false);
                } else {
                  this.utilizarTermoCancelamento = (response.data == "N" ? true : false);
                  this.exibirDialogCancelarNota(false);
                }
              },
              (error) => {
                console.log(error.response);
              }
            )
            .then(() => {});
      }
      NotaFiscalService.buscarTermoCancAssinado(this.idNotaFiscal)
        .then(
          (response) => {
            console.log(response);
            if (response.data && response.data.length > 0) {
              const termo = response.data[0];
              this.arquivoTermoAss = termo.arquivoTermo;
              this.nomeArquivoTermoAss = termo.nomeArquivoTermo;
              this.tipoArquivoTermoAss = termo.tipoArquivoTermo;
              
            } else {
              console.warn("A lista retornou vazia.");
            }
          },
          (error) => {
            console.error("Falha ao buscar termo:", error);
            if (error.response) {
                console.log("Detalhes do erro:", error.response);
            }
          }
        );
    });
  },

  data() {
    return {
      currentUser: null,
      termoCriado: false,
      diasPrazoCancelamento: null,
      mensagemCancelamento: null,
      mensagemCancPadrao: null,
      mensagemCancAdicional: null,
      notaPaga:false,
      mensagemPagamento: "A nota fiscal encontra-se Paga. Caso realmente deseje cancelar esta nota, informe o motivo (caso houver) e clique no botão abaixo para emissão do Termo de Pedido de Cancelamento de NFS-e. Este Termo deve ser ASSINADO pelo Prestador e Tomador do Serviço e entregue na Prefeitura.",
      showCancelarNota: false,
      idNotaFiscal: null,
      dataGeracao: null,
      validacao: true,
      observacao: null,
      utilizarTermoCancelamento : false,
      cancDamPetrolina: false,
      isEmissaoTesteValidacao: false,
      showUploadDialog: false,
      arquivoSelecionado: null,
      termoAnexado: false,
      arquivoTermoAss: null,
      nomeArquivoTermoAss: null,
      tipoArquivoTermoAss: null,
      showDeleteDialog: false,
      cancPorSolicitacao: false,
      termoAssinadoObj: []
    };
  },

  methods: {
    // Exibe o dialog de cancelamento
    exibirDialogCancelarNota(termoCriado) {
      this.termoCriado = termoCriado;
      this.showCancelarNota = true;
    },
    // Emite o termo de cancelamento
    emitirTermo() {
      if (this.termoCriado) {
        this.imprimirTermo();
      } else {
        this.cancelarNfseExec(true);
      }
    },
    cancelarNfse() {
      this.cancelarNfseExec(false);
    },
    // Executa o cancelamento da nota
    cancelarNfseExec(emitirTermo) {
      const servicoAtivo = this.isEmissaoTesteValidacao ? NotaFiscalTesteService : NotaFiscalService; 
      if(this.observacao){
        this.$parent.processando(true);
        this.$parent.erros = [];

        if (this.idNotaFiscal){
          servicoAtivo.cancelar(
            this.idNotaFiscal,
            this.observacao,
            this.utilizarTermoCancelamento,
            this.validacao,
            this.cancDamPetrolina,
            this.currentUser.usuario.idUsuario
          )
          .then(
            (data) => {
              var mensagem = this.utilizarTermoCancelamento
                ? "O Termo de Pedido de Cancelamento foi emitido e encaminhado para análise!"
                : "A Nota Fiscal foi Cancelada!";

              console.log(data);
              if(data.data == 'Pedido de cancelamento enviado com sucesso!'){
                this.$root.$emit("alert:success", data.data);
              }else{
                this.$root.$emit("alert:success", mensagem);
              }

              if (this.$parent.$options.name == "ConsultaNfse") {
                this.$parent.pesquisar();
              }
              this.observacao = "";
            },
            (error) => {
              this.$parent.erros.push(...error.response.data);
              console.log(error.response);
            }
          )
          .then(() => {
            if (
              emitirTermo &&
              (!this.$parent.erros || this.$parent.erros.length == 0)
            ) {
              this.imprimirTermo();
            }

            this.showCancelarNota = false;
            this.$parent.processando(false);
          });
        }
      } else {
        this.$root.$emit("alert:warn", "O Campo Observação é de Preenchimento Obrigatório!");
      }
    },
    // Imprime o termo de cancelamento
    imprimirTermo() {
      ReportService.imprimir("TermoCancelamento", [
        {
          param: "id",
          string: this.idNotaFiscal,
        },
        {
          param: "P_USUARIO",
          string: this.currentUser.usuario.nome,
        },
        {
          param: "P_DATA_EMISSAO",
          date: new Date(),
        },
      ])
        .then(
          () => {},
          (error) => {
            this.$root.$emit("alert:warn", "Erro ao Imprimir!");
            console.log(error);
          }
        )
        .then(() => {
          this.$parent.processando(false);
        });
    },
    // Anula um termo de cancelamento existente
    anularTermoCancelamento(){
      if(this.idNotaFiscal){
        NotaFiscalService.anularTermoCancelamento(
          this.idNotaFiscal,
        )
        .then(
          (data) =>{
            console.log(data);
            this.$toast.add({
              severity: "success",
              summary: "Termo de Cancelamento Anulado!",
              life: 3000
            });
            this.showCancelarNota = false;
            this.$parent.pesquisar();
          },
          (error) => {
            let errorMessage = "Houve um erro ao anular o Termo de Cancelamento!";
            if(error.response){
              errorMessage = error.response.data;
            }
            this.$toast.add({
              severity: "error",
              summary: errorMessage,
              life: 3000
            });
          }
        )
      }
    },
    onFileSelected(event) {
      const file = event.target.files[0];
      if (!file) return;
      const isPdf = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');

      if (!isPdf) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Formato Inválido',
          detail: 'Apenas arquivos no formato PDF são permitidos!',
          life: 5000
        });
        event.target.value = ""; 
        this.arquivoSelecionado = null;
        return;
      }
      const maxSize = 15 * 1024 * 1024;
      
      if (file.size > maxSize) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Arquivo muito grande',
          detail: 'O arquivo selecionado excede o limite de 15MB.',
          life: 5000
        });
        event.target.value = "";
        this.arquivoSelecionado = null;
        return;
      }
      this.arquivoSelecionado = file;
    },
    visualizarAnexo() {
      console.log("Arquivo atual: "+this.arquivoTermoAss);
      let conteudo = this.arquivoTermoAss;

      if (!conteudo) {
          return;
      }
      conteudo = conteudo.replace(/[\\"]/g, '');
      conteudo = conteudo.replace(/\s/g, '');
      if (conteudo.startsWith('x')) {
          let hexString = conteudo.substring(1);
          let binary = '';
          for (let i = 0; i < hexString.length; i += 2) {
              let hexPair = hexString.substr(i, 2);
              let byte = parseInt(hexPair, 16);
              binary += String.fromCharCode(byte);
          }
          conteudo = window.btoa(binary);          
      }
      ReportService.downloadFromBytes(
          conteudo, 
          this.nomeArquivoTermoAss, 
          this.tipoArquivoTermoAss
      );
    },
    enviarArquivo() {
      if (!this.arquivoSelecionado || !this.idNotaFiscal) return;

      this.$parent.processando(true);
      
      NotaFiscalService.uploadTermoCancelamento(this.idNotaFiscal, this.arquivoSelecionado)
        .then((response) => {
          console.log(response);
          this.$toast.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Arquivo anexado com sucesso!',
            life: 3000
          });
          
          this.termoAnexado = true;
          this.showUploadDialog = false;
          return NotaFiscalService.buscarTermoCancAssinado(this.idNotaFiscal);
        })
        .then((response) => {
          if (response && response.data) {
            this.termoAssinadoObj = response.data[0];
            this.arquivoTermoAss = this.termoAssinadoObj.arquivoTermo;
            this.nomeArquivoTermoAss = this.termoAssinadoObj.nomeArquivoTermo;
            this.tipoArquivoTermoAss = this.termoAssinadoObj.tipoArquivoTermo;
          }
        })
        .catch((error) => {
          let msg = "Erro ao enviar arquivo.";
          if (error.response && error.response.data) {
            msg = error.response.data;
          }
          this.$toast.add({
            severity: 'error',
            summary: 'Erro',
            detail: msg,
            life: 5000
          });
          console.error(error);
        })
        .finally(() => {
          this.$parent.processando(false);
          this.arquivoSelecionado = null;
        });
    },
    abrirModalUpload() {
      this.arquivoSelecionado = null;
      this.showUploadDialog = true;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },
    verificarSeExisteAnexo(idNota) {
      NotaFiscalService.checarExistenciaTermo(idNota)
        .then(response => {
          this.termoAnexado = response.data;
        })
        .catch(() => {
          this.termoAnexado = false;
        });
    },
    excluirAnexoExec() {
      this.$parent.processando(true);
      NotaFiscalService.excluirTermo(this.idNotaFiscal)
        .then(() => {
          this.$toast.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Anexo removido com sucesso!',
            life: 3000
          });
          
          this.termoAnexado = false;
          this.showDeleteDialog = false;
          
          this.arquivoTermoAss = null;
          this.nomeArquivoTermoAss = null;
          this.tipoArquivoTermoAss = null;
          this.arquivoSelecionado = null; 
        })
        .catch(error => {
          console.log(error);
          this.$toast.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Erro ao excluir anexo.',
            life: 3000
          });
        })
        .finally(() => {
          this.$parent.processando(false);
        });
    },
    limparSelecaoArquivo(event) {
      if (event) event.stopPropagation();
      this.arquivoSelecionado = null;
      if (this.$refs.fileInput) {
          this.$refs.fileInput.value = "";
      }
    },
  },

  computed: {
    loading() {
      return this.$parent.loading;
    }
  },
};
</script>

<style scoped>
  textarea {
    width: 100%;
    border-radius: 12px;
  }
  .mensagem-cancelamento {
    color: red;
    font-weight: bold;
    /* white-space: pre-wrap; */
  }
  .custom-upload-box {
    border: 2px dashed #ced4da;
    border-radius: 8px;
    padding: 3rem 1rem;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    background-color: #f8f9fa;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .custom-upload-box:hover {
    border-color: #3B82F6;
    background-color: #eff6ff;
    transform: translateY(-2px);
  }

  .custom-upload-box.has-file {
    border-style: solid;
    border-color: #28a745;
    background-color: #f0fff4;
  }

  .upload-title {
    font-weight: 600;
    font-size: 1.2rem;
    color: #495057;
    word-break: break-all;
  }

  .upload-subtitle {
    color: #6c757d;
    font-size: 0.9rem;
  }

  .btn-remove-selection {
    background-color: #ffe5e5 !important;
    color: #d32f2f !important;
    border: 1px solid #ffcdd2 !important;
    font-weight: 600;
    transition: all 0.3s ease;
  }

  .btn-remove-selection:hover {
    background-color: #dc3545 !important;
    color: #ffffff !important;
    border-color: #dc3545 !important;
    box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);
  }

  ::v-deep .dialog-arredondado .p-dialog-content {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    padding-bottom: 2rem;
  }

  ::v-deep .dialog-arredondado .p-dialog-footer {
    border-bottom-left-radius: 8px !important;
    border-bottom-right-radius: 8px !important;
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
    border-top: 1px solid #e9ecef;
    background-color: #f8f9fa;
    padding: 1rem;
  }

  .confirmation-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 1rem 0;
  }

  .warning-icon-wrapper {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: #ffe5e5;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.5rem;
    animation: pulse-red 2s infinite;
  }

  .warning-icon {
    font-size: 3rem;
    color: #d32f2f;
  }

  .confirmation-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #343a40;
  }

  .confirmation-message {
    font-size: 1.1rem;
    color: #495057;
    line-height: 1.5;
  }

  @keyframes pulse-red {
    0% {
      box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.2);
    }
    70% {
      box-shadow: 0 0 0 10px rgba(220, 53, 69, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);
    }
  }
</style>